import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

type State = {
  isDismissed: boolean
}

type Actions = {
  dismiss: () => void
}

type Store = State & Actions

export const useVipSupportStore = create<Store>()(
  persist(
    (set) => ({
      isDismissed: false,
      dismiss: () => set({ isDismissed: true }),
    }),
    {
      name: "app_founding_trader_campaign",
      storage: createJSONStorage(() => localStorage),
    }
  )
)
